if($('.type-detail').length){
    $(".availability-value .availability-label").each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    })
    $('.delivery-time').each(function() {
        $(this).html(function(){
          return $(this).html().replace("Zvolte variantu", "Dle varianty");
        })
    });
    $('.p-info-wrapper').append('<div class="availRow"></div>');
    if($('.delivery-time').length){
        $('.delivery-time').closest('tr').hide();
        if($('.p-info-wrapper #choose-variant').length){
            $('.availRow').append('<div class="deliveryDate variant">'+$('.delivery-time').html()+'</div>')
        }
        else{
            $('.availRow').append('<div class="deliveryDate">Můžeme doručit do: '+$('.delivery-time').html()+'</div>')
        }
        
        $('.availRow').append($('.delivery-time').closest('tr').find('.shipping-options'))
    }
    else{
        $('.availRow').append($('.shipping-options'))
    }
    $('.availRow').append($('.availability-value'))
    $('.basic-description table').wrap('<div class="overflow-table"></div>')
    $('.p-image-wrapper').append($('.product-top>div:not(".col-lg-6") .flags'))
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append($('.p-detail-info').clone())
    $('.p-info-wrapper').append('<div class="kosik"></div>')
    $('.kosik').append($('.p-final-price-wrapper'))
    $('.kosik').append($('.add-to-cart'))
    if($('.p-info-wrapper #choose-variant').length){
        $('.kosik').append($('.p-info-wrapper #choose-variant'))
    }
    else{

    }
    if($('#description .extended-description').length>0){
        $('li[data-testid="tabDescription"]').after('<li class="shp-tab" data-testid="tabRating" data-width=""><a href="#parametrsTab" class="shp-tab-link" role="tab" data-toggle="tab">Parametry</a></li>');
        $('#tab-content').append('<div id="parametrsTab" class="tab-pane fade in" role="tabpanel"></div>')
        $('#parametrsTab').append($('.extended-description'))
    }
    if($('#variants .variant-table').length){
        $('body').addClass('haveVariantProducts')
        $('#variants .variant-table .table-row').each(function(){
            console.log($(this).find('.variant-image+div .variant-name+span').text().trim())
            if($(this).find('.variant-image+div .variant-name+span').text().trim() !== 'Na dotaz'){

            }
            else{
                if(!$(this).find('.link-icon.watchdog').length){
                    $(this).append('<div class="table-col cart col-xs-6"><div class="variant-cart"></div></div>')
                    $(this).find('.variant-cart').append($('.p-info-wrapper .link-icon.watchdog').clone())
                }
                
            }
        })
    }
    else{
        if($('.availability-label').text().trim() === 'Na dotaz'){
            $('.kosik').append($('.link-icon.watchdog').clone())
            $('.shipping-options').hide()
            $('.sold-out').hide()
            $('.availability-label').text('Tento produkt momentálně není dostupný');
            $('.social-buttons-wrapper .link-icon.watchdog').hide();
        }
    }
    $('.p-info-wrapper').append('<div class="acountSale"><p>Toto zboží nakupují naši <a href="/vernostni-program/">věrní zákazníci</a> se slevou.</p></div>')
    $(document).ready(function(){

        
    let actionData = sessionStorage.getItem('actionPrices');
    function renderMessage(product) {
        const from = product.actionFrom;
        const until = product.actionUntil;
        const now = new Date();
        let valid = true;
        if (from) {
            const fromDate = new Date(from);
            if (now < fromDate) valid = false;
        }
        if (until) {
            const untilDate = new Date(until);
            if (now > untilDate) valid = false;
        }
        
        if (valid) {
            
            let text = `<div class="productActionPriceMessage">
                <div class="h4">Akční cena</div>`;
            if (until) {
                const d = new Date(until);
                const dateText = `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
                text += `<p><strong>Akce platí do ${dateText} nebo do vyprodání zásob.</strong></p>`;
            } else {
                text += `<p><strong>Akce platí do vyprodání zásob.</strong></p>`;
            }
            text += `</div>`;
            $('.p-info-wrapper').append(text);
        }
    }
    function processActionPrices(data) {
        const productCode = getShoptetDataLayer('product').codes[0].code.toString();
    
        if (!productCode) return;
        console.log(data)
        console.log(productCode)
        const match = data.find(p => p.code === productCode);
        if (match) renderMessage(match);
    }
    if (actionData) {
       
        try {
            const parsedData = JSON.parse(actionData);
            processActionPrices(parsedData);
        } catch (e) {
            console.warn('Chyba při parsování sessionStorage dat:', e);
        }
    } else {
        $.ajax({
            url: '/user/documents/productsActionPrice.json?v='+new Date().getMinutes(),
            method: 'GET',
            dataType: 'json',
            success: function (response) {
                sessionStorage.setItem('actionPrices', JSON.stringify(response));
                processActionPrices(response);
            },
            error: function () {
                console.warn('Nepodařilo se načíst JSON.');
            }
        });
    }
    })
}